import useLaunchpadSchema from 'modules/common/components/Layout/LaunchpadTasks/useLaunchpadSchema';
import {
    OPEN_CONNECT_BUSINESS_BANK_ACCOUNTS,
    S_CORP_ELECTION,
} from 'modules/common/components/Layout/LaunchpadTasks/useLaunchpadSchema/constants';
import { TaskStatus } from 'modules/common/components/LaunchpadProgress/LaunchpadProgress.interface';
import { useMember } from 'modules/common/queries/member';
import { isInOnboardingStages } from 'modules/common/utils/memberStage';

// Returns true when the member is in the OA phase of onboarding —
// all EM-relevant tasks (bank account, S-corp) are complete and
// only OA-owned tasks remain (payroll, establish beginning balance, accounting).
// Always returns false for activated members since OA phase is an onboarding-only concept.
export default function useIsInOAPhase() {
    const { data: member } = useMember();
    const { launchpadItems, isPendingLaunchpadTasks } = useLaunchpadSchema();

    if (!isInOnboardingStages(member?.stage)) {
        return { isInOAPhase: false, isPendingLaunchpadTasks: false };
    }

    const bankAccountTask = launchpadItems.find((item) => item.template_id === OPEN_CONNECT_BUSINESS_BANK_ACCOUNTS.id);
    const sCorpElectionTask = launchpadItems.find((item) => item.template_id === S_CORP_ELECTION.id);

    const isBankAccountComplete = bankAccountTask?.status === TaskStatus.COMPLETED;
    const isSCorpElectionComplete = !sCorpElectionTask || sCorpElectionTask.status === TaskStatus.COMPLETED;
    const isInOAPhase = isBankAccountComplete && isSCorpElectionComplete;

    return { isInOAPhase, isPendingLaunchpadTasks };
}
